export const KEY_CODE = {
    ESCAPE: 27
};